export default "__VITE_ASSET__CvuKYZFz__"